import "./ResourcesLayout.scss"

export default function ResourcesLayout({ title, resource_types, view_all, featured_content }) {
  // Ensure featured_content is always an array (extra safety)
  const featured = Array.isArray(featured_content) ? featured_content : (featured_content ? [featured_content] : []);

  // Split resource_types into two columns
  const splitIndex = Math.ceil((resource_types?.length || 0) / 2);
  const leftResources = resource_types.slice(0, splitIndex);
  const rightResources = resource_types.slice(splitIndex);

  return (
    <>
      {/* Header row */}
      <div className="menu-grid resources-layout">
        <h3 className="header-menu-column head-menu-title">{title}</h3>

        {/* Optional: if you want a header-area featured spot, otherwise keep empty */}
        <div className="header-menu-column featured-content"></div>
      </div>

      {/* Main grid */}
      <div className="menu-grid resources-layout">
        {/* Resource Types */}
        <div className="menu-column">
          <div className="grid grid-cols-2 gap-6">
            <ul className="menu-list">
              {leftResources.map((resource, idx) => (
                <li key={idx}>
                  <a href={resource.href} className="menu-link">
                    {resource.text}
                  </a>
                </li>
              ))}
            </ul>

            <ul className="menu-list">
              {rightResources.map((resource, idx) => (
                <li key={idx}>
                  <a href={resource.href} className="menu-link">
                    {resource.text}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {view_all && (
            <a href={view_all.href} className="view-all">
              {view_all.text}
            </a>
          )}
        </div>

        {/* Featured Content (array) */}
        {featured.length > 0 && (
          <div className="menu-column featured-content">
            <div className="featured-grid">
              {featured.slice(0, 2).map((item, idx) => (
                <article className="featured-card" key={idx}>
                  {/* Optional badge/image support if you add later */}
                  {item.badge && <span className="badge">{item.badge}</span>}
                  <p className="menu-title">{item.title}</p>
                  {item.description && <p className="menu-subtitle">{item.description}</p>}
                  {item.cta && (
                    <a href={item.cta.href} className="view-all">
                      {item.cta.text}
                    </a>
                  )}
                </article>
              ))}
            </div>
          </div>
        )}
      </div>
    </>
    
  );
}
